<template>
  <el-cascader
    ref="cascaderInstanceRef"
    v-model="innerValue"
    :options="options"
    @change="changeValue"
    filterable
    :clearable="clearable"
    :placeholder="placeholder"
    :props="casProps"
    :disabled="disabled"
    size="small"
    :show-all-levels="showAllLevels"
  />
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showAllLevels:{
      type: Boolean,
      default: true,
    },
    casProps: {
      type: Object,
    },
    modelValue: { type: Array },
  },
  computed: {
    innerValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val?.[val?.length - 1]);
        this.$emit("update:first", val?.[0]);
      },
    },
  },
  methods: {
    changeValue() {
      this.$emit("change");
    },
    getCheckedNodes() {
      return this.$refs.cascaderInstanceRef.getCheckedNodes();
    }
  },
};
</script>
